import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export type OembedResponse = {
  html: string;
};

export type OembedRequest = {
  url: string;
  maxwidth?: number;
  theme?: "light" | "dark";
};

export const oembedApi = createApi({
  reducerPath: "oembedApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_BASE_URL,
  }),
  endpoints: (build) => ({
    getOembed: build.query<OembedResponse, OembedRequest>({
      query: ({ url, maxwidth, theme }) => ({
        url: "/oembed",
        method: "GET",
        params: {
          url,
          maxwidth: maxwidth?.toString(),
          theme,
        },
      }),
    }),
  }),
});

export const { useGetOembedQuery } = oembedApi;
